<template>
    <div class="col-sm-4 col-md-7 div-center">
        <!--
        <div class="list-group">
            <span class="list-group-item" v-for="(item, index) in flows" :key="index">
                <router-link :to="{name: 'task', params: {uuid: item.uuid, creationTime: item.creationtime, startTime: item.starttime}}">
                    {{$t('flow.no')}}: {{item.uuid}}
                </router-link>
                <br/>
                <span><label>{{$t('flow.time')}}</label>: {{item.creationtime}}</span><br/>
                <span><label>{{$t('flow.status')}}</label>: {{$t(translateStatus(item.status))}}</span>
            </span>
        </div>
        -->
        <tabs>
            <tab name="processing" :selected="true">
                <div class="list-group">
                    <span class="list-group-item" v-for="(item, index) in processingFlows" :key="index">
                        <router-link :to="{name: 'task', params: {uuid: item.uuid, creationTime: item.creationtime, startTime: item.starttime}}">
                            {{$t('flow.no')}}: {{item.uuid}}
                        </router-link>
                        <br/>
                        <span><label>{{$t('flow.time')}}</label>: {{item.creationtime}}</span><br/>
                        <span><label>{{$t('flow.status')}}</label>: {{$t(translateStatus(item.status))}}</span>
                    </span>
                </div>
            </tab>
            <tab name="finished">
                <div class="list-group">
                    <span class="list-group-item" v-for="(item, index) in finishedFlows" :key="index">
                        <router-link :to="{name: 'task', params: {uuid: item.uuid, creationTime: item.creationtime, startTime: item.starttime}}">
                            {{$t('flow.no')}}: {{item.uuid}}
                        </router-link>
                        <br/>
                        <span><label>{{$t('flow.time')}}</label>: {{item.creationtime}}</span><br/>
                        <span><label>{{$t('flow.status')}}</label>: {{$t(translateStatus(item.status))}}</span>
                    </span>
                </div>
            </tab>
        </tabs>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {translateStatus} from '../utils/translate'

/*
import Vue from 'vue'
        /*
    components: {
        'tabs': {
            template: `
            <div>
                <div class="container">
                    <ul class="nav nav-tabs nav-justified">
                    <li v-for="tab in tabs" class="nav-item" :class="{'active': tab.isActive}">
                        <a :href="tab.href" @click="selectTab(tab)">{{tab.name}}</a>
                    </li>
                    </ul>
                </div>

                <div class="tabs-details">
                    <slot></slot>
                </div>
            </div>
            `,

            data() {
                return {tabs: []};
            },

            created() {
                this.tabs = this.$children;
            },

            methods: {
                selectTab(selectedTab) {
                    this.tabs.forEach(tab => {
                        tab.isActive = (tab.name == selectedTab.name);
                    });
                }
            }
        },

        'tab': {
            template: 
            `
                <div v-show="isActive"><slot></slot></div>
            `,

            props: {
                name: { required: true },
                selected: {default: false }
            },

            data() {
                return {
                    isActive: false
                };
            },

            computed: {
                href() {
                    //return '#'+this.name.toLowerCase().replace(//g, '-');
                    return '#'+this.name.toLowerCase();
                }
            },

            mounted() {
                this.isActive = this.selected;
            }
        }
        
Vue.component('tab', {
});
*/

import tabs from './comp/tabs'
import tab from './comp/tab'

export default {
    components: {
        tabs,
        tab
    },

    data() {
        return {
            newProcessingFlows: [],
            newFinishedFlows: [],
            newFlows: []
        }
    },

    created() {
        this.$store.dispatch('actGetFlow', this.$store.state.name)
    },

    computed: {
        flows: function() {
            if (this.flowList != null && this.flowList.length != 0) {
                this.newFlows = this.flowList.filter(function(elm) {
                    let jobj = JSON.parse(elm)
                    // Exclude these flows created by rejected, cancelled
                    // flowtype: 2=rejected, 3=cancelled
                    //if (!(jobj.flowtype == 0 && jobj.initiator == jobj.stations[0].target)) {
                    if (!((jobj.flowtype == 0 && jobj.initiator == jobj.stations[0].target) || jobj.flowtype == 2|| jobj.flowtype == 3)) {
					    //console.log('elm: ', elm)
                        return jobj  // This is string...
                   }
                })

                return this.newFlows.map(function(elm) {
                    //console.log('elm: ', elm)
                    return JSON.parse(elm)
                })
            }
        },
        processingFlows: function() {
            if (typeof(this.flows) != 'undefined') {
                return this.flows.filter(function(elm) {
                    //console.log('processing: ', typeof(elm), ", ", elm)
					// task: 0=new, 1=doing, 2=pending
                    return (elm.status == 0 || elm.status == 1 || elm.status == 2)
                })
            }
        },
        finishedFlows: function() {
            if (typeof(this.flows) != 'undefined') {
                return this.flows.filter(function(elm) {
                    //console.log('elm: ', elm.status, ', uuid: ', elm.uuid)
                    // task: 3=done, 4=rejected, 5=cancelled
                    return (elm.status == 3 || elm.status == 4 || elm.status == 5)
                })
            }
        },
        ...mapGetters({
            flowList: 'getFlow'
        })
    },

   methods: {
        translateStatus: translateStatus,
       ...mapActions([
           'actGetFlow'
       ])
   }
}
</script>



// WEBPACK FOOTER //
// src/pages/Flow.vue